export default function SettingsIntro() {
  return (
    <div className="text-center max-w-2xl mx-auto py-8" data-testid="settings-intro">
      <p className="text-slate-600 mb-3">
        Edit settings affecting <span className="font-semibold text-slate-800">TC Auditors (Pty) Ltd</span> by
        selecting from the list above.
      </p>
      <p className="text-slate-600">
        <span className="font-semibold text-slate-800">Global settings</span> are available by clicking on
        the profile icon at the top-right.
      </p>
    </div>
  );
}
